import React from "react";
import GlobalContext from "./GlobalContext";
import NewsTile from "./NewsTile";
import RecordingTile from "./RecordingTile";
import WorkTile from "./WorkTile";
import FAQBlock from "./FAQBlock";

function ResultsDisplay(){
  const global = React.useContext(GlobalContext);

  const blocks = global.state.records.map(record => {
    switch(global.state.type){
      case 'faq':
        return (
          <FAQBlock 
            key={ `tile-${record.id}` }
            id={ record.id }
            title={ record.title }
            content={ record.content }
          />
        );
      case 'news':
        return (
          <NewsTile 
            key={ `tile-${record.id}` }
            date={ record.date }
            imageAlt={ record.imageAlt }
            imageUrl={ record.imageUrl }
            slug={ record.slug }
            title={ record.title }
          />
        );
      case 'recordings':
        return (
          <RecordingTile 
            key={ `tile-${record.id}` }
            imageAlt={ record.imageAlt }
            imageUrl={ record.imageUrl }
            slug={ record.slug }
            title={ record.title }
          />
        );
      default:
        return (
          <WorkTile 
            key={ `tile-${record.id}` }
            slug={ record.slug }
            title={ record.title }
            excerpt={ record.excerpt }
          />
        );
    }
  });

  return (
    <div className={`results-display ${global.state.type}`}>{ blocks }</div>
  );
}

export default ResultsDisplay;